import { T } from "@/i18n";
import { MoreHorizontal, MoreVertical } from "lucide-react";
import { Key, ReactNode } from "react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "./ui/sidebar";

interface NavItem {
  label: string;
  icon: () => JSX.Element;
  itemWrapper?: (props: { children?: ReactNode; key?: Key }) => JSX.Element;
  className?: string;
}

export type NavItems = NavItem[][];

export function NavActions({
  items: data,
  iconOrientation = "horizontal",
}: {
  items: NavItems;
  iconOrientation?: "horizontal" | "vertical";
}) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="h-7 w-7 data-[state=open]:bg-accent"
        >
          {iconOrientation === "horizontal" ? (
            <MoreHorizontal />
          ) : (
            <MoreVertical />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="w-56 overflow-hidden rounded-lg p-0"
        align="end"
      >
        <Sidebar collapsible="none" className="bg-transparent">
          <SidebarContent>
            {data.map((group, index) => (
              <SidebarGroup key={index} className="border-b last:border-none">
                <SidebarGroupContent className="gap-0">
                  <SidebarMenu>
                    {group.map((item, index) => {
                      const child = (
                        <SidebarMenuItem
                          key={item.itemWrapper ? undefined : index}
                        >
                          <SidebarMenuButton className={item.className}>
                            <item.icon />{" "}
                            <span>
                              <T tKey={item.label} />
                            </span>
                          </SidebarMenuButton>
                        </SidebarMenuItem>
                      );
                      return item.itemWrapper
                        ? item.itemWrapper({ children: child, key: index })
                        : child;
                    })}
                  </SidebarMenu>
                </SidebarGroupContent>
              </SidebarGroup>
            ))}
          </SidebarContent>
        </Sidebar>
      </PopoverContent>
    </Popover>
  );
}
